import countries from "libs/countries.json";

const getCountryFromCode = (code) => {
  return countries?.find((item) => item?.code === code);
};

export default getCountryFromCode;
